export let stdreqColumns = () => {
  let indexColumns = [{
    key: 'desc_codpos',
    name: '',
    labelCodapp: 'STD_REQP3',
    labelIndex: '20',
    style: 'min-width: 150px;'
  }, {
    key: 'numappl',
    name: '',
    labelCodapp: 'STD_REQP3',
    labelIndex: '30',
    style: 'min-width: 100px;'
  }, {
    key: 'codempid',
    name: '',
    labelCodapp: 'STD_REQP3',
    labelIndex: '40',
    style: 'min-width: 100px;'
  }, {
    key: 'namempe',
    name: '',
    labelCodapp: 'STD_REQP3',
    labelIndex: '50',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_statappl',
    name: '',
    labelCodapp: 'STD_REQP3',
    labelIndex: '60',
    style: 'min-width: 100px;'
  }, {
    key: 'dtefoll',
    name: '',
    labelCodapp: 'STD_REQP3',
    labelIndex: '70',
    class: 'align-center',
    style: 'min-width: 100px;',
    dataType: 'date'
  }]

  return {
    en: {
      index: indexColumns
    },
    th: {
      index: indexColumns
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/columns/stdreq.js